import React from 'react'
import './HEAD.css'
const HEAD = () => {
    return (
        <header className='HEAD-sticky-header'>
            <h1 className='HEAD-word'>
                Nola | 開発中
            </h1>
        </header>
    )
}

export default HEAD